const FETCH_PROVIDER_REPORTS = 'fetch_providerReports';
const FETCH_PROVIDER_REPORTS_CSV = 'fetch_providerReports_csv';
const FETCH_PROVIDER_REPORTS_TOTAL = 'fetch_providerReports_total';
const FETCH_PROVIDER_REPORT = 'fetch_providerReport';
const DELETE_PROVIDER_REPORT = 'delete_providerReport';
const PERSIST_PROVIDER_REPORT = 'persist_providerReport';
export default {
    FETCH_PROVIDER_REPORTS,
    FETCH_PROVIDER_REPORTS_CSV,
    FETCH_PROVIDER_REPORTS_TOTAL,
    FETCH_PROVIDER_REPORT,
    DELETE_PROVIDER_REPORT,
    PERSIST_PROVIDER_REPORT,
};
